import React, { useEffect, useRef } from 'react';
import Highcharts from 'highcharts';
import { formatNumber } from '../../../utils/DefaultFunction';

const OptimizationTrends = ({ data }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    if (chartRef.current && data && Object.keys(data).length) {
      const categories = Object.keys(data); // months
      const totalSaving = categories.map(key => data[key].totalSaving);

      Highcharts.chart(chartRef.current, {
        chart: {
            type: 'line',
            backgroundColor: 'white',
            height: 500,
            spacingLeft: 0, // let it expand automatically
            marginLeft: null // let Highcharts decide
          },
          

        title: { text: null },
        credits: { enabled: false },
        legend: { enabled: false },

        xAxis: {
          categories,
          lineWidth: 1,
          tickLength: 5,
          labels: { style: { fontSize: '10px', color: '#64748b' } },
        },

        yAxis: {
          visible: true,
          title: { text: 'Total Saving'},
          labels: {
            style: { fontSize: '10px' },
            formatter: function () {
              return formatNumber(this.value,"en-US",true) // show formatted saving values
            },
          },
          gridLineWidth: 1,
        },

        plotOptions: {
          line: {
            lineWidth: 2,
            color: '#10b981',
            marker: {
              enabled: true,
              symbol: 'circle',
              radius: 4,
              fillColor: '#ffffff',
              lineWidth: 2,
              lineColor: '#10b981',
            },
          },
        },

        tooltip: {
          useHTML: true,
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          borderWidth: 1,
          borderColor: '#ccc',
          shadow: false,
          formatter: function () {
            const month = categories[this.point.index];
            const value = (totalSaving[this.point.index]).toFixed(2);
            return `
            <span>${month}</span>
              <br/> <br/>
              <span style="color:#10b981">Total Savings : ${formatNumber(value)}</span> 
             
            `;
          },
        },

        series: [
          {
            name: 'Total Saving',
            data: totalSaving,
            color: '#10b981',
          },
        ],
      });
    }
  }, [data]);

  return <div ref={chartRef} className="w-full" />;
};

export default OptimizationTrends;
